export default "/_next/static/fonts/45ccb331268e699d0fd0755ff741c21d.woff2";